import OtsUploadFile from './OtsUploadFile'
import OtsCustomDialog from './OtsCustomDialog'
import OtsMainTitle from './OtsMainTitle'
import LayoutOne from './LayoutOne'
import OtsTable from './OtsTable'
import OtsPagination from './OtsPagination'
import OtsTableGroup from './OtsTableGroup'
import OtsRefer from './OtsRefer'
import OtsTableNew from './OtsTableNew'
import OtsTableGroupNew from './OtsTableGroupNew'
import OtsPopPro from './OtsPopPro'
import OtsTipline from './OtsTipline'
import OtsEditor from './OtsEditor'
import OtsPasswordTooltip from './OtsPasswordTooltip'
const packages = [
    OtsUploadFile,
    OtsCustomDialog,
    OtsMainTitle,
    LayoutOne,
    OtsTable,
    OtsPagination,
    OtsTableGroup,
    OtsRefer,
    OtsPasswordTooltip,
    OtsTableNew,
    OtsTableGroupNew,
    OtsTipline,
    OtsEditor,
]

const install = Vue => {
    Vue.use(OtsPopPro)
    packages.forEach(item => {
        Vue.component(item.name,item)
    })
}

export default install
